/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type IrrLocationType = 'UNKNOWN' | 'S3' | 'GCP';

export const IrrLocationType = {

    UNKNOWN: 'UNKNOWN' as IrrLocationType,

    S3: 'S3' as IrrLocationType,

    GCP: 'GCP' as IrrLocationType
};

